<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    id="abnormal-dialog"
    :show-close="false"
    >
    <template>
      <span v-if="isInCooperation == 0 || isInCooperation == 3 || isInCooperation == 4">私密商品仅限合作分销商可见</span>
       <span v-if="isInCooperation == 2">您暂无权查看当前商品</span>
      <span v-if="isInCooperation == 12">私密商品仅限合作分销商可见，您已提交合作申请，请等待审核</span>
      <span v-if="isInCooperation == 11">私密商品仅限合作分销商可见，供销商已提交合作申请</span>
    </template>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleBack">返回供销商小店</el-button>
     <template>
        <el-button v-if="isInCooperation == 0|| isInCooperation == 3 || isInCooperation == 4 "  @click="handleRelationBind" type="primary">申请合作</el-button>
        <el-button v-if="isInCooperation == 12" disabled>待授权中...</el-button>
        <el-button v-if="isInCooperation == 11" @click="goExamine" type="primary">去审核</el-button>
     </template>
    </span>
    </el-dialog>
</template>

<script>
import {relationBind} from "@api/distributor";
import {get} from "lodash";
import { mapGetters } from 'vuex';
export default {
  props: ['isInCooperation'],
  data() {
    return{
      dialogVisible: false,
    }
  },
  computed: {
    ...mapGetters(['routerPrefix']),
  },
  methods: {
    handleBack() {
      this.dialogVisible = false;
      this.$router.replace({
        name:  `${this.routerPrefix}SupplierMineInfo`,
        query: {
          supplierId: this.$route.query.supplierId
        }
      })
    },
     async handleRelationBind() {
      const { companyId: distributorCompanyId } = this.$store.getters.userInfo;
      let supplierCompanyId = get(this.$route, 'query.supplierId', '');
      let res = await relationBind({
        distributorCompanyId,
        needAudit: 1,
        supplierCompanyId,
      })
      if (res.result === 1) {
        this.$message.success('已像供销商提交合作申请')
      }
    },
    method_open() {
      this.dialogVisible = true
    },
    goExamine() {
      this.$router.push({
        name: `${this.routerPrefix}SupplierMine`,
        query: {
          requestState: 11
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
   ::v-deep .el-dialog__body {
    min-height: 0;
  }
  
</style>

<style>
#abnormal-dialog  {
  backdrop-filter: blur(2px);
}
</style>
